import { BASE_URL, CITY } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ICity, ICityInput } from "models/city";

export async function getCities(params: string = "") : Promise<ICity[]> {
  const response = await axios.get(BASE_URL + CITY + params);
  return response.data;
}
export async function addCity(data: ICityInput) {
  const response = await axios.post(BASE_URL + CITY, data);
  return response.data;
}
export async function editCity(data: ICityInput, id: string) {
  
  const response = await axios.patch(BASE_URL + CITY + "/" + id, data);
  return response.data;
}

export async function deleteCity(id: string) {
  const response = await axios.delete(BASE_URL + CITY + "/" + id);
  return response.data;
}

export const CityCells: HeadCell[] = [
  {
    id: "cityName",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "cityNameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  {
    id: "countryCode",
    numeric: false,
    disablePadding: false,
    label: "T_country_code",
  },
  {
    id: "countryName",
    numeric: false,
    disablePadding: false,
    label: "T_country_name",
  },
  {
    id: "countryNameAr",
    numeric: false,
    disablePadding: false,
    label: "T_country_name_Ar",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
